import React from "react";
import { useAuth } from "../../../context/API_Client";
import HoverToDisplayFullTitle from "../../../reusableComponents/HoverToDisplayFullTitle";
import MoreOptionsForTable from "../moreOptionsForTable";
import { sortDateTime } from "../../utils/utils";

const UsersSchema = (
  deleteUserData,
  editUserData,
  resendInvite,
  actionValue,
  operationPermissions
) => {
  const { isAuthorizedPermission } = useAuth();
  const handleActionData = (value) => {
    if (value) {
      editUserData(value);
      deleteUserData(value);
      resendInvite(value);
    }
  };

  const handleActionValue = (value) => {
    if (value) {
      actionValue(value);
    }
  };
  const schema = {
    metadata: {
      title: "Users",
      minHeight: 600,
      position: "relative",
      showTitle: false,
      rowHeight: 65,
      defaultSortInfo: { name: "updatedOn", dir: -1 },
    },
    fields: [
      {
        name: "name",
        header: "Name",
        visible: true,
        type: "string",
        filtering: false,
        sortable: true,
        minWidth: 200,
        defaultFlex: 1,
        textAlign: "center",
        render: ({ data }) => {
          const userName = data?.name;
          return (
            <span
              style={{
                marginLeft: "-12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <HoverToDisplayFullTitle title={userName} len={24} />
            </span>
          );
        },
      },
      {
        name: "email",
        header: "Email Address",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 250,
        defaultFlex: 1,
        textAlign: "center",
        sortable: false,
        render: ({ value }) => {
          return (
            <span
              style={{
                marginLeft: "-12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <HoverToDisplayFullTitle title={value} len={30} />
            </span>
          );
        },
      },
      {
        name: "businessUnitsNames",
        header: "Business Unit",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 250,
        defaultFlex: 1,
        textAlign: "center",
        sortable: false,
        render: ({ value }) => {
          const joinedBusinessUnits = value?.join(" ");
          return (
            <span
              style={{
                marginLeft: "-12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <HoverToDisplayFullTitle title={joinedBusinessUnits} len={30} />
            </span>
          );
        },
      },
      {
        name: "rolesName",
        header: "Role",
        visible: true,
        type: "string",
        filtering: false,
        textAlign: "center",
        minWidth: 200,
        defaultFlex: 1,
        sortable: false,
        render: ({ value }) => {
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  display: "flex",
                  marginLeft: "-12px",
                  maxWidth: "550px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {value}
              </span>
            </div>
          );
        },
      },
      {
        name: "status",
        header: "Status",
        visible: true,
        type: "string",
        filtering: false,
        textAlign: "center",
        minWidth: 150,
        defaultFlex: 1,
        sortable: false,
        render: ({ value }) => {
          let backgroundColor;
          let color;

          if (value === "Active") {
            backgroundColor = "var(--comms-positive-sub, #D5FBD2)";
            color = "var(--comms-positive, #0B6A48)";
          } else if (value === "Pending") {
            backgroundColor = "var(--Comms-Warning-sub, #FBEFCB)";
            color = "var(--Comms-Warning, #9E5707)";
          }
          return (
            <span
              style={{
                marginLeft: "-10px",
                paddingBottom: "6px",
                paddingRight: "8px",
                paddingLeft: "8px",
                paddingTop: "5px",
                borderRadius: "8px",
                backgroundColor,
                color,
                fontFamily: "Poppins",
              }}
            >
              {value}
            </span>
          );
        },
      },
      // {
      //   name: "createdOn",
      //   header: "Created At",
      //   visible: true,
      //   type: "string",
      //   filtering: false,
      //   textAlign: "center",
      //   minWidth: 250,
      //   defaultFlex: 1,
      //   sort: sortDateTime,
      //   render: ({ value }) => {
      //     return (
      //       <span
      //         style={{
      //           marginLeft: "-15px",
      //           paddingBottom: "6px",
      //           paddingRight: "8px",
      //           paddingLeft: "8px",
      //           paddingTop: "5px",
      //           borderRadius: "8px",
      //           fontFamily: "Poppins",
      //         }}
      //       >
      //         {value}
      //       </span>
      //     );
      //   },
      // },
      {
        name: "updatedOn",
        header: "Saved At",
        visible: true,
        type: "string",
        filtering: false,
        textAlign: "center",
        minWidth: 250,
        defaultFlex: 1,
        sort: sortDateTime,
        render: ({ value }) => {
          return (
            <span
              style={{
                marginLeft: "-15px",
                paddingBottom: "6px",
                paddingRight: "8px",
                paddingLeft: "8px",
                paddingTop: "5px",
                borderRadius: "8px",
                fontFamily: "Poppins",
              }}
            >
              {value}
            </span>
          );
        },
      },
      {
        name: "id",
        header: "Actions",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 100,
        defaultFlex: 1,
        textAlign: "center",
        sortable: false,
        render: (data) => (
          <>
            <MoreOptionsForTable
              options={["Edit User", "Delete"]}
              data={data?.data}
              handleActionValue={handleActionValue}
              handleActionData={handleActionData}
              dataForUser={true}
              disableDeleteForActiveUser={true}
              operationPermissions={operationPermissions}
            />
          </>
        ),
      },
    ],
  };
  return schema;
};

export default UsersSchema;
